import { render, staticRenderFns } from "./icon-affiliate.vue?vue&type=template&id=7b0a22b6"
import script from "./icon-affiliate.vue?vue&type=script&lang=js"
export * from "./icon-affiliate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports